// removed by extract-text-webpack-plugin
module.exports = {"About":"About__About__Nt9kt","Video":"About__Video__2CUJ1"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.css
// module id = 626
// module chunks = 0